import * as React from 'react';
import { ButtonTertiary } from 'ui';
import { FiChevronDown } from 'react-icons/fi';
import { withForceUpdateTerminal, ForceUpdateTerminalProps } from 'ui/common/force-update-terminal';
import { MdHelpOutline } from 'react-icons/md';
import { Tooltip, TooltipDirections } from 'ui/common/tooltip/tooltip';
import styles from './drawer-with-bar.scss';

interface DrawerWithBarComponentProps {
  title: string;
  disclaimerMessage?: string;
  barContent?: React.ReactNode;
  drawerContent: React.ReactNode;
  initiallyOpen?: boolean;
}

type DrawerWithBarProps = DrawerWithBarComponentProps & ForceUpdateTerminalProps & React.PropsWithChildren;

interface DrawerWithBarComponentState {
  isOpenDrawer: boolean;
  initiallyOpen: boolean;
  isClosing: boolean;
}

class DrawerWithBarComponent extends React.Component<DrawerWithBarProps, DrawerWithBarComponentState> {
  constructor(props: DrawerWithBarProps) {
    super(props);
    this.state = {
      isOpenDrawer: !!props.initiallyOpen,
      initiallyOpen: !!props.initiallyOpen,
      isClosing: false
    };
  }

  private toggle = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (this.state.isOpenDrawer) {
      this.setState({ isClosing: true });

      setTimeout(() => {
        this.setState({
          isOpenDrawer: !this.state.isOpenDrawer,
          initiallyOpen: true,
          isClosing: false
        } as DrawerWithBarComponentState);
      }, 500);

    } else {
      this.setState({
        isOpenDrawer: !this.state.isOpenDrawer,
        initiallyOpen: true
      } as DrawerWithBarComponentState);
    }
  };

  private handleAnimationEnd = (e: React.AnimationEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      this.props.refreshForceUpdateHash();
    }
  };

  public render(): JSX.Element {
    const { isOpenDrawer, isClosing } = this.state;
    const { barContent, disclaimerMessage } = this.props;

    const animateOutStyles = isClosing ? 'closing-animation' : '';
    const btnOpen = isOpenDrawer && !isClosing ? styles.btnOpen : '';
    const filterOpenState = isOpenDrawer ? 'with-open-filters' : 'with-closed-filters';

    return <>
      <div className={styles.drawerBar}>
        <div className={`${styles.drawerBarBtn} drawer-button ${btnOpen}`}
          data-toggle="collapse" onClick={this.toggle}>
          <ButtonTertiary>
            <span>{this.props.title}</span>
            {disclaimerMessage &&
              <Tooltip
                className={'d-block'}
                title={disclaimerMessage}
                center={true}
                wide={true}
                delayed={true}
                direction={TooltipDirections.top}
                colorLight={true}>
                <MdHelpOutline />
              </Tooltip>}
            <FiChevronDown className={styles.rotateIcon} />
          </ButtonTertiary>
        </div>
        <div className={styles.barContent}>
          {!!barContent && barContent}
        </div>
      </div>
      <div className={`${styles.searchContent} ${animateOutStyles} ${filterOpenState}`} onAnimationEnd={this.handleAnimationEnd}>
        <div className="filters" onAnimationEnd={this.handleAnimationEnd}>
          {this.props.drawerContent}
        </div>
        {this.props.children}
      </div>
    </>;
  }
}

export const DrawerWithBar = withForceUpdateTerminal<DrawerWithBarProps>(DrawerWithBarComponent);
